import Images from 'constants/images';
import { useTranslation } from 'react-i18next';

export const useDashboardTrees = () => {
  const { t } = useTranslation();

  return [
    {
      area: 'ictRisksToTpp',
      title: t('DASHBOARD_TREES.TPP_RISK'),
      imgSrc: Images.dataEntryAreas,
      href: '/dashboard/ict-risk-to-tpp',
    },
    {
      area: 'entityToFunction',
      title: t('DASHBOARD_TREES.FUNCTION_SERVICES'),
      imgSrc: Images.dataEntryAreas,
      href: '/dashboard/entity-to-function',
    },
    {
      area: 'entityToTPP',
      title: t('DASHBOARD_TREES.TPP_CONTRACT_SYSTEM_DATA'),
      imgSrc: Images.dataEntryAreas,
      href: '/dashboard/entity-to-tpp',
    },
    {
      area: 'entityToFunctionReverse',
      title: t('DASHBOARD_TREES.FUNCTION_DATA_REVERSE'),
      imgSrc: Images.dataEntryAreas,
      href: '/dashboard/entity-to-function-reverse',
    },
  ];
};
